import { useCurrentUser } from '@bonusly/who-am-i';

import { useAwards } from '../../../api/hooks/awards';
import { AwardType } from '../../../api/hooks/enums';

export const useGiveableAwards = () => {
	const user = useCurrentUser();
	const { data: awards, isLoading } = useAwards(
		{
			params: {
				type: AwardType.Manual,
				givable_by_user: user.id,
			},
		},
		{
			select: (data) => data.data.result.items,
		}
	);

	return {
		awards: awards || [],
		isLoading,
	};
};
